module.exports = __webpack_public_path__ + "assets/img/54@3x.828bc22b.png";